import React, { useRef, useState, useEffect } from "react"
import * as Style from "./VideoSection.module.scss"
import Stamat from "../animation/Animation"
import "../../../node_modules/video-react/dist/video-react.css"
import ReactPlayer from "react-player"


const Video = props => {
  const playerRef = useRef(null)

  const [duration, setDuration] = useState(0)
  // const [controlSpeed, setControlSpeed] = useState(1)
  let mzminutes = Math.floor(duration / 60);
  let mzseconds = Math.floor(duration - (mzminutes * 60));
  const handleDuration = (duration) => {
    console.log('onDuration', duration)
    setDuration(duration)
  }

  // const videoSpeedControl = (event) => {
  //   if (event.target.dataset.type === '0.50') {
  //     setControlSpeed(0.50)
  //   }
  //   if (event.target.dataset.type === '0.75') {
  //     setControlSpeed(0.75)
  //   }
  //   if (event.target.dataset.type === '1') {
  //     setControlSpeed(1)
  //   }
  //   if (event.target.dataset.type === '1.50') {
  //     setControlSpeed(1.50)
  //   }
  //   if (event.target.dataset.type === '2') {
  //     setControlSpeed(2)
  //   }
  // }

  // useEffect(() => {
  //   let videoSpeed = playerRef.current.props.playbackRate;
  //   setControlSpeed(videoSpeed)
  // }, [])


  return (
    <div className={Style.videoAndStamat}>
      <div className={Style.playerWrapper}>
        <ReactPlayer
          className={Style.reactPlayer}
          url={`${props.videoContent}#t=0.1`}
          width='100%'
          height='100%'
          controls={true}
          ref={playerRef}
          onDuration={handleDuration}
        />
        {/* <details className={Style.speedDropdown} >
          <summary>Скорост на възпроизвеждане: {controlSpeed}</summary>
          <button data-type={"0.50"} onClick={videoSpeedControl}>x 0.50</button>
          <button data-type={"0.75"} onClick={videoSpeedControl}>x 0.75</button>
          <button data-type={"1"} onClick={videoSpeedControl}>x 1</button>
          <button data-type={"1.50"} onClick={videoSpeedControl}>x 1.50</button>
          <button data-type={"2"} onClick={videoSpeedControl}>x 2</button>
        </details> */}
        <div className={Style.overStamat}>
          <div className={Style.Stamat}>
            <Stamat />
          </div>
        </div>
      </div>


    </div>
  )
}

export default Video
